import React, { useEffect, useState } from "react";

const left = (end) => Math.max(0, new Date(end).getTime() - Date.now());

export const FlashCountdown = ({ end, onEnd }) => {
  const [ms, setMs] = useState(() => left(end));
  useEffect(() => {
    setMs(left(end));
    const t = setInterval(() => { const v = left(end); setMs(v); if (!v) { clearInterval(t); onEnd?.(); } }, 1000);
    return () => clearInterval(t);
  }, [end, onEnd]);
  const s = Math.floor(ms / 1000);
  const parts = [["g", Math.floor(s / 86400)], ["h", Math.floor(s / 3600) % 24], ["m", Math.floor(s / 60) % 60], ["s", s % 60]].filter(([u, v], i) => i > 0 || v > 0);
  return (
    <span className="flex gap-1" data-testid="flash-countdown">
      {parts.map(([u, v]) => <span key={u} className="min-w-[38px] h-9 px-1 rounded-lg bg-white/15 flex flex-col items-center justify-center leading-none"><b className="text-[15px] tabular-nums">{String(v).padStart(2, "0")}</b><span className="text-[9px] uppercase text-white/70 mt-0.5">{u}</span></span>)}
    </span>
  );
};
